import { ProxyRequestException__get_Response, ProxyRequestException__get_StatusCode, ProxyRequestException } from "../Bfs.Web.Kundenportal/fable_modules/Fable.Remoting.Client.7.32.0/Types.fs.js";
import { ServerError_$reflection, ServerError, AuthenticationError } from "../Bfs.Web.Shared.FSharp/Errors.fs.js";
import { SimpleJson_tryParse } from "../Bfs.Web.Kundenportal/fable_modules/Fable.SimpleJson.3.24.0/./SimpleJson.fs.js";
import { Convert_fromJson } from "../Bfs.Web.Kundenportal/fable_modules/Fable.SimpleJson.3.24.0/./Json.Converter.fs.js";
import { createTypeInfo } from "../Bfs.Web.Kundenportal/fable_modules/Fable.SimpleJson.3.24.0/./TypeInfo.Converter.fs.js";
import { anonRecord_type } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Cmd_OfAsync_start, Cmd_OfAsyncWith_either } from "../Bfs.Web.Kundenportal/fable_modules/Fable.Elmish.4.2.0/./cmd.fs.js";
import { FSharpResult$2 } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Result.js";

function exnToError(e) {
    let matchValue;
    if (e instanceof ProxyRequestException) {
        const ex = e;
        if (ProxyRequestException__get_StatusCode(ex) === 401) {
            return new ServerError(1, [new AuthenticationError()]);
        }
        else {
            try {
                return ((matchValue = SimpleJson_tryParse(ProxyRequestException__get_Response(ex).ResponseBody), (matchValue != null) ? Convert_fromJson(matchValue, createTypeInfo(anonRecord_type(["error", ServerError_$reflection()]))) : (() => {
                    throw new Error("Couldn\'t parse the input JSON string because it seems to be invalid");
                })())).error;
            }
            catch (matchValue_1) {
                return new ServerError(0, [e.message]);
            }
        }
    }
    else {
        return new ServerError(0, [e.message]);
    }
}

export function eitherAsResult(f, args, resultMsg) {
    return Cmd_OfAsyncWith_either((x) => {
        Cmd_OfAsync_start(x);
    }, f, args, (arg) => resultMsg(new FSharpResult$2(0, [arg])), (arg_2) => resultMsg(new FSharpResult$2(1, [exnToError(arg_2)])));
}

//# sourceMappingURL=Server.fs.js.map
